/* eslint-disable */
import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import React, { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import moment from 'moment';

// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
} from '@mui/material';
import {
  getToken,
  removeUserSession,
  tokenIsExpired,
  refreshTokenIsExpired,
  getRefreshToken,
  renewToken,
  setRefreshUserSession,
} from '../utils/common';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
// components
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: '', label: 'Date & Time', alignRight: false },
  { id: '', label: 'User', alignRight: false },
  { id: '', label: 'Role', alignRight: false },
  { id: '', label: 'Action', alignRight: false },
];

const names = [
  'Dashboard',
  'User Management',
  'Rule',
  'Alerts',
  'Report',
  'Watchlist',
  'Bulletin',
  'Infromation',
  'Activity Log',
];

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis?.map((el) => el[0]);
}

export default function UserPage(props) {
  const [open, setOpen] = useState(null);
  const [order, setOrder] = useState('desc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('timestamp');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [visible, setVisible] = React.useState(false);
  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);
  const [total, settotal] = useState(1);
  const [page, setpage] = useState(0);
  const [limit, setlimit] = useState(20);

  const closeHandler = () => {
    setVisible(false);
    console.log('closed');
  };

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
    console.log(property);
    let sort = '';
    if (property === 'Date & Time') {
      sort = 'timestamp';
    } else if (property === 'User') {
      sort = 'identifier';
    } else if (property === 'Role') {
      sort = 'role';
    } else if (property === 'Action') {
      sort = 'message';
    }

    fetchInfo(
      window.REACT_APP_API_PURE +
        `activity/list?message=${filterName}&type=${filterName}&identifier=${filterName}&limit=${rowsPerPage}&page=1&sort=${sort}&order=${
          isAsc ? 'desc' : 'asc'
        }`
    );
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = data?.data?.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected?.slice(1));
    } else if (selectedIndex === selected?.length - 1) {
      newSelected = newSelected.concat(selected?.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected?.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event) => {
    setpage(event);
    fetchInfo(
      window.REACT_APP_API_PURE +
        `activity/list?message=${filterName}&type=${filterName}&identifier=${filterName}&page=${
          event + 1
        }&limit=${rowsPerPage}&sort=${orderBy}&order=${order}`
    );
  };

  const handleChangeRowsPerPage = (event) => {
    setpage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
    fetchInfo(window.REACT_APP_API_PURE + `activity/list?limit=${parseInt(event.target.value, 10)}&page=` + 0);
  };

  const handleFilterByName = (event) => {
    // setPage(0);
    setFilterName(event.target.value);
    fetchInfo(
      window.REACT_APP_API_PURE +
        `activity/list?message=${event.target.value}&type=${event.target.value}&identifier=${event.target.value}&limit=${rowsPerPage}&page=1`
    );
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - data?.data?.length) : 0;

  const filteredUsers = applySortFilter(data?.data, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredUsers?.length && !!filterName;

  const fetchInfo = (url) => {
    return fetch(url, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    })
      .then((res) => res.json())
      .then((d) => {
        setData(d.data);
        settotal(d.total);
      });
  };
  React.useEffect(() => {
    fetchInfo(window.REACT_APP_API_PURE + `activity/list?sort=${orderBy}&order=${order}`);
  }, []);

  return (
    <>
      <Helmet>
        <title> Activity Log | SmartShield </title>
      </Helmet>
      <Container>
        <Card>
          <UserListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} />
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800, borderRadius: 2, border: '1px solid #e0e0e0' }}>
              <Table>
                <UserListHead
                  order={order}
                  hideSortIcon={false}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={data?.length}
                  numSelected={selected?.length}
                  onRequestSort={handleRequestSort}
                  assign="label"
                  //onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {data?.map((item, itemIndex) => {
                    const inputTimestamp = item.timestamp;
                    const dateTime = new Date(inputTimestamp);
                    dateTime.setUTCHours(dateTime.getUTCHours());

                    const year = dateTime.getFullYear();
                    const month = String(dateTime.getMonth() + 1).padStart(2, '0');
                    const day = String(dateTime.getDate()).padStart(2, '0');
                    const hours = String(dateTime.getHours()).padStart(2, '0');
                    const minutes = String(dateTime.getMinutes()).padStart(2, '0');
                    const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}`;
                    return (
                      <TableRow
                        hover
                        key={itemIndex}
                        sx={{
                          '&:last-child td, &:last-child th': { border: 0 },
                        }}
                      >
                        <TableCell align="left" sx={{ maxWidth: 20 }}>
                          {itemIndex + 1}
                        </TableCell>
                        <TableCell component="th" scope="row" sx={{ minWidth: 80, maxWidth: 80 }}>
                          {formattedDateTime}
                        </TableCell>
                        <TableCell component="th" scope="row" sx={{ minWidth: 180, maxWidth: 180 }}>
                          {item.identifier}
                        </TableCell>
                        <TableCell component="th" scope="row" sx={{ minWidth: 80, maxWidth: 80 }}>
                          {item.role}
                        </TableCell>
                        <TableCell component="th" scope="row" sx={{ maxWidth: 300, minWidth: 300 }}>
                          {item.message}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[20, 50, 100]}
            component="div"
            count={total}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={(event, value) => handleChangePage(value)}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem>
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          Edit
        </MenuItem>

        <MenuItem sx={{ color: 'error.main' }}>
          <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover>
    </>
  );
}
